import Header from '../Component/Header'
import Footer from '../Component/Footer'
import Breadcrumb from '../Component/Breadcrumb'
const VoiceMessage = () => {
    return (
        <>
            <Header />
            <Breadcrumb title="Voice Message" midBreadcrumb="Gallery" mainBreadcrumb="Voice Message" ></Breadcrumb>
            <div className='inner-page'>
                <div className='container'>
                    <div className="row">
                        <div className="col-12">
                            <h2 className="mainhead" >Voice Message</h2>
                        </div>
                    </div>
                    <br/>
                    <div className="row audio-sec g-3">
                        <div className="col">
                            <article>
                                <audio controls>
                                    <source src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/voice/1.mp3" type="audio/mpeg" />
                                </audio>
                                <div className="audio-content">
                                    <p><strong>Voice SMS:</strong> Easter</p>
                                    <p><strong>Voice of:</strong> Sr. Helen D’ Costa</p>
                                    <p><strong>Uploaded On:</strong> 28<sup>th</sup> September 2018</p>
                                </div>
                            </article>
                        </div>
                        <div className="col">
                            <article>
                                <audio controls>
                                    <source src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/voice/2.mp3" type="audio/mpeg" />
                                </audio>
                                <div className="audio-content">
                                    <p><strong>Voice SMS:</strong> Easter</p>
                                    <p><strong>Voice of:</strong> Sr. Helen D’ Costa</p>
                                    <p><strong>Uploaded On:</strong> 28<sup>th</sup> September 2018</p>
                                </div>
                            </article>
                        </div>
                        <div className="col">
                            <article>
                                <audio controls>
                                    <source src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/voice/3.mp3" type="audio/mpeg" />
                                </audio>
                                <div className="audio-content">
                                    <p><strong>Voice SMS:</strong> Easter</p>
                                    <p><strong>Voice of:</strong> Sr. Helen D’ Costa</p>
                                    <p><strong>Uploaded On:</strong> 28<sup>th</sup> September 2018</p>
                                </div>
                            </article>
                        </div>
                        <div className="col">
                            <article>
                                <audio controls>
                                    <source src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/voice/4.mp3" type="audio/mpeg" />
                                </audio>
                                <div className="audio-content">
                                    <p><strong>Voice SMS:</strong> Easter</p>
                                    <p><strong>Voice of:</strong> Sr. Helen D’ Costa</p>
                                    <p><strong>Uploaded On:</strong> 28<sup>th</sup> September 2018</p>
                                </div>
                            </article>
                        </div>
                        <div className="col">
                            <article>
                                <audio controls>
                                    <source src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/voice/5.mp3" type="audio/mpeg" />
                                </audio>
                                <div className="audio-content">
                                    <p><strong>Voice SMS:</strong> Easter</p>
                                    <p><strong>Voice of:</strong> Sr. Helen D’ Costa</p>
                                    <p><strong>Uploaded On:</strong> 28<sup>th</sup> September 2018</p>
                                </div>
                            </article>
                        </div>
                        <div className="col">
                            <article>
                                <audio controls>
                                    <source src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/voice/6.mp3" type="audio/mpeg" />
                                </audio>
                                <div className="audio-content">
                                    <p><strong>Voice SMS:</strong> Easter</p>
                                    <p><strong>Voice of:</strong> Sr. Helen D’ Costa</p>
                                    <p><strong>Uploaded On:</strong> 28<sup>th</sup> September 2018</p>
                                </div>
                            </article>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
}
export default VoiceMessage